import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App.jsx";
import { AppErrorBoundary } from "./components/ErrorBoundary.jsx";

// Initialize Sentry for error tracking
Sentry.init({
  dsn:
    import.meta.env.VITE_SENTRY_DSN ||
    "https://d0c1c610533ef68e4d424df102743b85@o4510727721582592.ingest.us.sentry.io/4510727733379072",
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/vouchee-unified.onrender.com\/api/,
    /^https:\/\/vouchee\.app\/api/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Filter out expected 405/404 noise from the business profile lookup waterfall
  // These are intentional fallback attempts, not real errors
  beforeSend(event) {
    // Filter out dev environment noise
    if (
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1")
    ) {
      return null;
    }
    const errorValue = event?.exception?.values?.[0]?.value || "";
    // Suppress AxiosError 405s that come from the business profile slug-lookup waterfall
    if (
      errorValue.includes("status code 405") ||
      errorValue.includes("status code 404")
    ) {
      return null;
    }
    return event;
  },
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);
// Force rebuild Fri Dec 12 19:32:09 EST 2025
